// Import statements
import classNames from "classnames";
import { useCopyToClipboard } from 'usehooks-ts';
import { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CARDS_LIST from "./constants/cards";
import CopyIcon from './CopyIcon'; // Ensure correct path is specified

// Shuffle function
function shuffleArray(array) {
  let currentIndex = array.length, randomIndex;
  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }
  return array;
}

// Card display functional component
function Card({ card, isSelected, onClick }) {
  const cardClasses = classNames(
    "w-full aspect-[54/88] bg-slate-300 rounded bg-origin-border bg-center bg-cover bg-no-repeat drop-shadow-sm",
    isSelected ? "bg-slate-500" : "bg-card-pattern"
  );

  const cardStyle = isSelected ? { backgroundImage: `url(/cards/${card.img})` } : {};

  return (
    <button
      className={cardClasses}
      style={cardStyle}
      onClick={onClick}
    />
  );
}

// Main App component
function App() {
  const [selectedCards, setSelectedCards] = useState([]);
  const [shuffledCards, setShuffledCards] = useState([]);
  const [copiedText, copyToClipboard] = useCopyToClipboard();

  // Shuffle cards initially
  useEffect(() => {
    setShuffledCards(shuffleArray([...CARDS_LIST]));
  }, []);

  const handleCardSelect = cardImg => () => setSelectedCards(prev => [...prev, cardImg]);

  const selectedCardNames = selectedCards
    .map(cardImg => shuffledCards.find(card => card.img === cardImg)?.name)
    .join(', ');

  // Handle copy to clipboard functionality
  const handleCopy = async () => {
    try {
      await copyToClipboard(selectedCardNames);
      console.log('Copied!', selectedCardNames);
      toast.success("Скопировано!");
    } catch (error) {
      console.error('Failed to copy!', error);
      toast.error("Не удалось скопировать");
    }
  };

  return (
    <div key={new Date().getTime()} className="flex flex-col gap-8">
      <div className="rounded-2xl flex m-5 py-8 px-4 justify-center bg-3C2D2D drop-shadow-lg">
        <p className="text-2xl text-center">Выберите карты расположенные ниже. Листай вниз до конца.</p>
      </div>
      <div className="grid grid-cols-6 grid-rows-12 gap-3 px-3">
        {shuffledCards.map(card => (
          <Card
            key={card.img}
            card={card}
            isSelected={selectedCards.includes(card.img)}
            onClick={handleCardSelect(card.img)}
          />
        ))}
      </div>
      <div className="flex flex-col gap-4 m-5">
        <div className="rounded-2xl bg-default-100 bg-4A2F2F px-4 py-3 drop-shadow-lg min-h-12 items-center flex">
          <p className="font-semibold">{selectedCardNames}</p>
        </div>
        <button className="flex gap-3 bg-60360E rounded-full py-3 px-4 justify-center items-center font-semibold drop-shadow-lg"
            onClick={handleCopy}>
          <CopyIcon/> {/* SVG Icon */}
          Скопировать текст карт
        </button>
      </div>
      <ToastContainer/>
    </div>
  );
}

export default App;
